import React from "react";

const UzbekistanFlag = (props: any) => {
  return (
    <svg
      width="24"
      height="20"
      viewBox="0 0 120 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      style={{ borderRadius: "50%" }}
    >
      <g clipPath="url(#clip0_706_22815)">
        <path d="M120 0H0V40H120V0Z" fill="#56CCF2" />
        <path d="M120 40H0V80H120V40Z" fill="#219653" />
        <path d="M120 40H0" stroke="#EB5757" strokeWidth="32" />
        <path d="M120 40H0" stroke="#F2F2F2" strokeWidth="22" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M24.6484 2.13522C19.91 2.92116 16.2969 7.03864 16.2969 12C16.2969 16.9614 19.91 21.0788 24.6484 21.8648C24.1122 21.9537 23.5615 22 23 22C17.4772 22 13 17.5228 13 12C13 6.47715 17.4772 2 23 2C23.5615 2 24.1122 2.04628 24.6484 2.13522Z"
          fill="#F2F2F2"
        />
        <path
          d="M31 18L31.449 19.382H32.9021L31.7265 20.2361L32.1756 21.618L31 20.7639L29.8244 21.618L30.2735 20.2361L29.0979 19.382H30.551L31 18Z"
          fill="#F2F2F2"
        />
        <path
          d="M39 18L39.449 19.382H40.9021L39.7265 20.2361L40.1756 21.618L39 20.7639L37.8244 21.618L38.2735 20.2361L37.0979 19.382H38.551L39 18Z"
          fill="#F2F2F2"
        />
        <path
          d="M47 18L47.449 19.382H48.9021L47.7265 20.2361L48.1756 21.618L47 20.7639L45.8244 21.618L46.2735 20.2361L45.0979 19.382H46.551L47 18Z"
          fill="#F2F2F2"
        />
        <path
          d="M55.5 18L55.949 19.382H57.4021L56.2265 20.2361L56.6756 21.618L55.5 20.7639L54.3244 21.618L54.7735 20.2361L53.5979 19.382H55.051L55.5 18Z"
          fill="#F2F2F2"
        />
        <path
          d="M64 18L64.449 19.382H65.9021L64.7265 20.2361L65.1756 21.618L64 20.7639L62.8244 21.618L63.2735 20.2361L62.0979 19.382H63.551L64 18Z"
          fill="#F2F2F2"
        />
        <path
          d="M39 10L39.449 11.382H40.9021L39.7265 12.2361L40.1756 13.618L39 12.7639L37.8244 13.618L38.2735 12.2361L37.0979 11.382H38.551L39 10Z"
          fill="#F2F2F2"
        />
        <path
          d="M47 10L47.449 11.382H48.9021L47.7265 12.2361L48.1756 13.618L47 12.7639L45.8244 13.618L46.2735 12.2361L45.0979 11.382H46.551L47 10Z"
          fill="#F2F2F2"
        />
        <path
          d="M55.5 10L55.949 11.382H57.4021L56.2265 12.2361L56.6756 13.618L55.5 12.7639L54.3244 13.618L54.7735 12.2361L53.5979 11.382H55.051L55.5 10Z"
          fill="#F2F2F2"
        />
        <path
          d="M64 10L64.449 11.382H65.9021L64.7265 12.2361L65.1756 13.618L64 12.7639L62.8244 13.618L63.2735 12.2361L62.0979 11.382H63.551L64 10Z"
          fill="#F2F2F2"
        />
        <path
          d="M47 2L47.449 3.38197H48.9021L47.7265 4.23607L48.1756 5.61803L47 4.76393L45.8244 5.61803L46.2735 4.23607L45.0979 3.38197H46.551L47 2Z"
          fill="#F2F2F2"
        />
        <path
          d="M55.5 2L55.949 3.38197H57.4021L56.2265 4.23607L56.6756 5.61803L55.5 4.76393L54.3244 5.61803L54.7735 4.23607L53.5979 3.38197H55.051L55.5 2Z"
          fill="#F2F2F2"
        />
        <path
          d="M64 2L64.449 3.38197H65.9021L64.7265 4.23607L65.1756 5.61803L64 4.76393L62.8244 5.61803L63.2735 4.23607L62.0979 3.38197H63.551L64 2Z"
          fill="#F2F2F2"
        />
      </g>
      <defs>
        <clipPath id="clip0_706_22815">
          <rect width="120" height="80" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default UzbekistanFlag;
